import { useEffect } from 'react';
import Intercom from '@intercom/messenger-js-sdk';
import { useSelector } from 'react-redux';
import { RootState } from '../../store/store';

export default function IntercomManager() {
    const { phoneNumber, isAuthenticated } = useSelector((state: RootState) => state.user);

    useEffect(() => {
        // If user is authenticated and we have a phone number (user ID)
        if (isAuthenticated && phoneNumber) {
            Intercom({
                app_id: 'jqxd4cnj',
                user_id: phoneNumber,
                name: phoneNumber, // Using phone number as name since we don't have separate name field
                // email: user.email, // Not available in current user slice
                // created_at: user.createdAt, // Not available in current user slice
            });
        } else {
            // Initialize for guests/visitors
            Intercom({
                app_id: 'jqxd4cnj',
            });
        }
    }, [phoneNumber, isAuthenticated]);

    return null;
}
